





































































































/* eslint-disable @typescript-eslint/camelcase */

import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "../../plugins";

interface UserItem {
  userId: string;
  userName: string;
}

interface UserId {
  userId: string;
}

export default Vue.extend({
  name: "Edit",
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      timer: 0,
      userOptions: new Array<UserItem>(),
      ruleForm: {
        code: "",
        description: "",
        adminUserIds: new Array<UserId>(),
        name: "",
        resourceQuota: {
          limits_cpu: "8",
          limits_memory: "16Gi",
          requests_cpu: "6",
          requests_memory: "12Gi"
        }
      }
    };
  },
  computed: {
    rules: function() {
      if (this.isEdit) {
        return {
          description: [{ required: true, message: "", trigger: "blur" }],
          adminUserIds: [{ required: true, message: "", trigger: "change" }]
        };
      } else {
        return {
          description: [{ required: true, message: "", trigger: "blur" }],
          adminUserIds: [{ required: true, message: "", trigger: "change" }],
          name: [
            {
              required: true,
              message: "",
              trigger: "blur",
              pattern: /^(?!\d+$)[\da-zA-Z\u4e00-\u9fa5]+$/
            }
          ],
          code: [
            {
              required: true,
              message: "",
              trigger: "change",
              pattern: /(?=^[a-z])[a-z0-9-]*(?=[a-z0-9]$)/
            }
          ]
        };
      }
    }
  },
  mounted() {
    this.remoteMethod("");
  },
  methods: {
    show(data?: any) {
      if (data) {
        // 编辑模式
        this.initData(data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.dialog = true;
    },
    remoteMethod(query: string) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.loading = true;
        axios.get(`/user?q=${encodeURIComponent(query)}`).then(res => {
          this.userOptions = new Array<UserItem>();
          res.data.data.list.map((user: any) => {
            this.userOptions.push({
              userId: user.id,
              userName: user.userName
            });
          });
          this.loading = false;
        });
      }, 400);
    },
    quit() {
      this.ruleForm = (this as any).$options.data().ruleForm;
      (this.$refs.ruleForm as Form).resetFields();
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          if (this.isEdit) {
            this.edit();
          } else {
            this.create();
          }
        }
      });
    },
    edit() {
      const data = Object.assign({}, this.ruleForm, {
        resourceQuota: {
          "limits.cpu": this.ruleForm.resourceQuota.limits_cpu,
          "limits.memory": this.ruleForm.resourceQuota.limits_memory,
          "requests.cpu": this.ruleForm.resourceQuota.requests_cpu,
          "requests.memory": this.ruleForm.resourceQuota.requests_memory
        }
      });
      axios.put("/tenant", data).then(() => {
        this.$message.success("租户空间修改成功");
        this.quit();
        this.$emit("afterEdit");
      });
    },
    create() {
      const data = Object.assign({}, this.ruleForm, {
        resourceQuota: {
          "limits.cpu": this.ruleForm.resourceQuota.limits_cpu,
          "limits.memory": this.ruleForm.resourceQuota.limits_memory,
          "requests.cpu": this.ruleForm.resourceQuota.requests_cpu,
          "requests.memory": this.ruleForm.resourceQuota.requests_memory
        }
      });
      axios.post("/tenant", data).then(() => {
        this.$message.success("租户空间创建成功");
        this.quit();
        this.$emit("afterEdit");
      });
    },
    initData(data: any) {
      for (const item in data) {
        if (Object.prototype.hasOwnProperty.call(data, item)) {
          if (item === "adminUsers") {
            this.ruleForm.adminUserIds = new Array<UserId>();
            data[item].map((user: any) => {
              this.ruleForm.adminUserIds.push(user.userId);
            });
          } else if (item === "resourceQuota") {
            // 编辑时读取 resourceQuota
            this.ruleForm.resourceQuota = {
              limits_cpu: data.resourceQuota["limits.cpu"],
              limits_memory: data.resourceQuota["limits.memory"],
              requests_cpu: data.resourceQuota["requests.cpu"],
              requests_memory: data.resourceQuota["requests.memory"]
            };
          } else {
            (this.ruleForm as any)[item] = data[this.transform(item)];
          }
        }
      }
    },
    transform(value: string) {
      if ("_".indexOf(value) === -1) return value;
      return value.replace(/_/g, ".");
    }
  }
});
